export const returnErrorOrMessage = (e: any, message: string) => {
  if (typeof e?.data === 'string') {
    return message;
  }

  return e?.error || e?.message || e?.data.message || e || message;
};
